import React from 'react'
import style from '../scss/components/SimpleKeypoints.module.scss'
import classNames from 'classnames'
import Column from './Column'
import BrandRow from './BrandRow'
import { Fade } from "react-awesome-reveal"
import safeImg from '../assets/safe.png'
import safeImg2x from '../assets/safe@2x.png'
import safeImg3x from '../assets/safe@3x.png'
import graphImg from '../assets/graph.png'
import graphImg2x from '../assets/graph@2x.png'
import graphImg3x from '../assets/graph@3x.png'
import palmImg from '../assets/palm.png'
import palmImg2x from '../assets/palm@2x.png'
import palmImg3x from '../assets/palm@3x.png'

const SimpleKeypoints = () => {
    return (
        <div className={style.Wrapper}>
            <BrandRow>
                <Column>
                    <Fade direction={'down'} triggerOnce={true}>
                        <div className={style.Main}>
                            <div className={style.ImageWrapper}>
                                <img src={safeImg} srcSet={`${safeImg2x} 2x, ${safeImg3x} 3x`} alt={''}/>
                            </div>
                            <h2>Saa & hoia (!) rohkem kliente</h2>
                            <p>Kui Sa midagi taga ajad, siis kipub see eest ära jooksma.
                                Kasuta Salon Secretsi meetodeid selleks, et klientide tagaajamise asemel muutuda magnetiks,
                                kes neid mängleva kergusega hoopiski enda juurde meelitab.
                            </p>
                        </div>
                    </Fade>
                </Column>
                <Column>
                    <Fade direction={'down'} triggerOnce={true}>
                        <div className={style.Main}>
                            <div className={classNames(style.ImageWrapper, style.Middle)}>
                                <img src={graphImg} srcSet={`${graphImg2x} 2x, ${graphImg3x} 3x`} alt={''}/>
                            </div>
                            <h2>Paista konkurentide seast silma</h2>
                            <p>Peavalud seoses teiste ilusalongide seast silmapaistmisega on nüüd minevik.
                                Anname Sulle parimad tööriistad ja taktikad selleks, et kliendid alati just Sind eelistaksid.
                            </p>
                        </div>
                    </Fade>
                </Column>
                <Column>
                    <Fade direction={'down'} triggerOnce={true}>
                        <div className={style.Main}>
                            <div className={style.ImageWrapper}>
                                <img src={palmImg} srcSet={`${palmImg2x} 2x, ${palmImg3x} 3x`} alt={''}/>
                            </div>
                            <h2>Kasvata käivet & naudi vabadust</h2>
                            <p>Avasta, kuidas tippilutegijad oma sissetulekut suurendavad,
                                ilma et nad ohverdaksid aega oma pere ja sõpradega veetmise arvelt.
                            </p>
                        </div>
                    </Fade>
                </Column>
            </BrandRow>
        </div>
    )
}

export default SimpleKeypoints
